// THE PHONE NUMBER AS THE OWNER TYPES IT — A TYPING AID, NOT A RULE (WALK-FIX-1, R236).
//
// The letter's printed form has one writer, the server (`functions/src/v2/letter/phone.ts` `printedPhone`): whatever this
// sheet sends, the letterhead prints a US number as "(402) 555-0123" and anything else as typed. This mirrors that shape
// while the owner types, so the box shows what the letter will print, and decides nothing: it never refuses a
// character, never drops one it cannot place, and leaves anything it cannot read as a US number exactly as typed.
//   - typing a US number builds it up: "(402", "(402) 555", "(402) 555-0123" — never ending on a mark the owner did not
//     type, so Backspace always takes a digit;
//   - a pasted one is reshaped once it is whole: 402.555.0123, +1 402 555 0123, 1-402-555-0123;
//   - a "+" other than +1, a leading 0 or 1 still being typed, letters (an extension) or more than ten digits: as typed.
// Registered in docs/THIN_CLIENT_DEBT.md at birth.

const US = /^[2-9]\d{9}$/;

function shaped(ten: string): string {
  if (ten.length <= 3) return `(${ten}`;
  if (ten.length <= 6) return `(${ten.slice(0, 3)}) ${ten.slice(3)}`;
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

/** What the phone box shows after the owner's latest keystroke or paste. */
export function phoneAsTyped(raw: string): string {
  if (/[A-Za-z]/.test(raw)) return raw;
  const digits = raw.replace(/\D/g, "");
  if (digits === "") return raw;
  // A whole number with its country code, typed or pasted: reshaped.
  if (digits.length === 11 && digits.startsWith("1") && US.test(digits.slice(1))) return shaped(digits.slice(1));
  // A "+", or a leading 0 or 1, is someone typing a country code or another country's number: left alone until whole.
  if (raw.trim().startsWith("+") || !/^[2-9]/.test(digits) || digits.length > 10) return raw;
  return shaped(digits);
}
